import { SpinPrizePublic } from '../types/api'
import html2canvas from 'html2canvas'
import { createRoot } from 'react-dom/client'
import StoriesPrize from '../pages/FortuneWheelPage/components/storiesPrize/StoriesPrize'

/**
 * Генерирует canvas изображение для Instagram Story формата (1080x1920)
 * на основе данных приза, используя React компонент StoriesPrize
 */
export const generateStoryImage = async (
  prize: SpinPrizePublic
): Promise<Blob> => {
  return new Promise(async (resolve, reject) => {
    try {
      // Создаем временный контейнер для рендера React компонента
      const container = document.createElement('div')
      container.style.position = 'fixed'
      container.style.left = '-9999px'
      container.style.top = '0'
      container.style.width = '1080px'
      container.style.height = '1920px'
      document.body.appendChild(container)

      // Рендерим React компонент
      const root = createRoot(container)

      // Используем Promise для ожидания рендера
      await new Promise<void>((resolveRender) => {
        root.render(
          <StoriesPrize
            image={prize.stories_icon_url || prize.icon_url}
            topText={prize.stories_header_text || 'POV: когда получаешь приз в Secret Wheel'}
            bottomText={prize.stories_text || 'Подробнее в кондитерке'}
          />
        )

        // Даем время на рендер и загрузку изображений
        setTimeout(resolveRender, 1000)
      })

      // Преобразуем DOM элемент в canvas с помощью html2canvas
      const canvas = await html2canvas(container, {
        width: 1080,
        height: 1920,
        scale: 1,
        useCORS: true,
        allowTaint: false, // Изменено на false для корректной работы с CORS
        backgroundColor: '#c54343',
        logging: false, // Отключаем логирование для продакшена
        proxy: undefined, // Можно добавить прокси если нужно
      })

      // Очищаем временный контейнер
      root.unmount()
      document.body.removeChild(container)

      // Конвертируем canvas в blob
      canvas.toBlob(
        blob => {
          if (blob) {
            resolve(blob)
          } else {
            reject(new Error('Не удалось создать изображение'))
          }
        },
        'image/png',
        1.0
      )
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Генерирует Data URL изображения для предварительного просмотра
 */
export const generateStoryImageDataUrl = async (
  prize: SpinPrizePublic
): Promise<string> => {
  const blob = await generateStoryImage(prize)
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result)
      } else {
        reject(new Error('Не удалось создать Data URL'))
      }
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
